import { useDyteClient } from '@dytesdk/react-web-core';
// Wrapper around Dyte's useDyteClient(),
// so that users of raam-shared package shouldn't need to install the Dyte packages
export const useMeetingClient = (dyteClientParams) => useDyteClient(dyteClientParams);
